export function normalizeId(id) {
  if (!id) {
    return id;
  }

  return id.split('-').pop();
}



// WEBPACK FOOTER //
// ./src/transport/utils/normalize-id.js